var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.275,
    height: 13.75,
    viewBox: "0 0 19.275 13.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "seen-svgrepo-com",
    d: "M2.421,12.833a1.382,1.382,0,0,1,1.953.033L8.8,17.451,18.993,7.381a1.382,1.382,0,0,1,1.934,1.965L9.749,20.4a1.382,1.382,0,0,1-.967.4H8.769a1.382,1.382,0,0,1-.978-.414l-5.4-5.6a1.382,1.382,0,0,1,.033-1.953Z",
    transform: "translate(-2 -7.047)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.8a6870ce32ae8490d772f0946056be5f.svg";
export { ForwardRef as ReactComponent };